import BaseAPI from '../base'

function sendSurveyResult(data) {
    return BaseAPI.sendPost(`aiwaiter/survey`, data);
}

export default {
    sendSurveyResult
}